import React from "react";
import "../App.css";

const landing = () => {
  return (
    <div className="h-2/4 m-auto">
      <div className="h-[73vh] md:h-[80vh] flex justify-center items-center slide-animation ">
          <img
            className="w-[100%] h-[100%] object-cover opacity-90"
            src="https://images.unsplash.com/photo-1586023492125-27b2c045efd7?q=80&w=1916&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
            alt=""
          />
        </div>

        
      </div>
    
  );
};

export default landing;
